import { createAction, props } from '@ngrx/store';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { EstadosLaboratorio } from './estados-laboratorio.model';


// LOAD
export const entityEstadosLaboratorioLoadRequest = createAction(
  '[ENTITYESTADOSLABORATORIO] Load Request'
);

export const entityEstadosLaboratorioLoadFailure = createAction(
  '[ENTITYESTADOSLABORATORIO] Load Failure',
  props<{ error: Error }>()
);

export const entityEstadosLaboratorioLoadSuccess = createAction(
  '[ENTITYESTADOSLABORATORIO] Load Success',
  props<{ items: EstadosLaboratorio[] }>()
);
